import React, {useState} from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import Inputfield from '../InputField/Inputfield'
import Radiofield from '../Radiofield/Radiofield'
import '../Addemployee/addemployee.css'
import './addkpi.css'
import axios from 'axios'
import { useCookies } from 'react-cookie';


const Addkpi = ({sendnotice, params}) => {
    const API = 'https://'
    const [cookies] = useCookies(['Token']);
    const [values, setValues] = useState({
        countryname: ''
    })

    const handleSubmit = () =>{
        // Submit Data
        if(params.id !== undefined || params.id > 0){
            // console.log("edit command")
            UpdateRequest(params.id)
        } else{
            // console.log("normal open")
            UpdateRequest(undefined)
        }
    }

    const UpdateRequest = async(props) =>{
        // setConfirmload(true)
        sendnotice({
          action: "load",
          text: 'Sending Data...'
        })
        try {
          var config = {
            method: props !== undefined ? 'PUT' : 'POST',
            url: props !== undefined ? `${API}/updatkpi/${props}` : `${API}/addkpi`,
            data: {
              country: values.countryname
            },
            headers: { 
              Authorization: "Bearer " + cookies.Token
            }
          };

          // console.log(config)
      
          await axios(config).then((response) => {
          // console.log(response.data.data);
          if(response.data.success === true){
            sendnotice({
              action: "notload",
              text: response.data.message
            })
          }else{
            // do something
          }});
        } catch(e){
          if(e.message.includes('401')){
            // catch error
          } else{
            // catch error
          }
        }
    }

    const handleCountryname = (incoming) =>{
      setValues({...values, countryname: incoming})
    }

    const handleClose = () =>{
      sendnotice({
        action: "close",
        text: ''
      })
    }

  return (
    <div className='overlay-container'>
            <div className='overlay-addemployee-container'>
                <div className='top-container-apprais-notif'>
                    <span>ADD PERFORMANCE INDEX</span>
                    <AiOutlineCloseCircle id='closeIcon-notifc' onClick={handleClose}/>
                </div>

                <div className='top-addemployee-container-body'>
                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <Inputfield personname={handleCountryname} fieldlabel="Key Performance Index" placehold="Key Performance Index..." typeid="text"/>
                        </div>
                    </div>
                    <div className='top-addemployee-submit-row'>
                        <button id='broadcast-buttn' onClick={handleSubmit}>ADD INDEX</button>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Addkpi